import { HttpClient } from '@/shared/lib/http-client';

export const fetchFeedbacks = async() => {
  const response = await HttpClient.get('/feedbacks',);

  return response.data?.data;
};
